import { render, staticRenderFns } from "./pulsetzbs.vue?vue&type=template&id=e6fa301a&scoped=true&"
import script from "./pulsetzbs.vue?vue&type=script&lang=js&"
export * from "./pulsetzbs.vue?vue&type=script&lang=js&"
import style0 from "./pulsetzbs.vue?vue&type=style&index=0&id=e6fa301a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6fa301a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6fa301a')) {
      api.createRecord('e6fa301a', component.options)
    } else {
      api.reload('e6fa301a', component.options)
    }
    module.hot.accept("./pulsetzbs.vue?vue&type=template&id=e6fa301a&scoped=true&", function () {
      api.rerender('e6fa301a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/print/components/pulsetzbs.vue"
export default component.exports